export enum SecureConfirmType {
  TwoFA = 'two_fa',
  SecurePassword = 'secure_password',
  LoginPassword = 'login_password',
}
